import { jsx as i } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { useStyleConfig as r, Button as m, IconButton as B } from "@chakra-ui/react";
const h = u(
  ({ __css: n = {}, magic: e = !1, size: c, trackId: s, variant: o, ...t }, a) => {
    const d = r("ButtonTheme", {
      variant: o,
      size: c
    }), l = e ? r("MagicButton") : {};
    return /* @__PURE__ */ i(
      m,
      {
        __css: { ...d, ...l, __css: n },
        "data-left-icon": t.leftIcon ? "true" : void 0,
        "data-right-icon": t.rightIcon ? "true" : void 0,
        ref: a,
        "track-id": s,
        variant: "unstyled",
        ...t
      }
    );
  }
), f = u(
  ({ __css: n = {}, size: e, trackId: c, variant: s, ...o }, t) => {
    const a = r("IconButtonTheme", { variant: s, size: e, ...o });
    return /* @__PURE__ */ i(
      B,
      {
        __css: { ...a, ...n },
        ref: t,
        "track-id": c,
        variant: "unstyled",
        ...o
      }
    );
  }
);
f.displayName = "IconButton";
export {
  h as Button,
  f as IconButton
};
//# sourceMappingURL=Button.es.js.map
